import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { User } from '@app/core/_models'
import { UserService } from '@app/core/_services/user.service'
import { TooltipModule } from 'primeng/tooltip'
import { Subject, takeUntil } from 'rxjs'
const BLANK_PROFILE_IMAGE = 'assets/images/blank_profile.png'

@Component({
    selector: 'fm-profile-link',
    imports: [CommonModule, RouterModule, TooltipModule],
    templateUrl: './profile-link.component.html',
    styleUrl: './profile-link.component.scss',
})
export class ProfileLinkComponent {
    private ngUnsubscribe: Subject<any> = new Subject<any>()

    public userAvatar: string
    constructor(private userService: UserService) {}

    public onProfileImageFailedToLoad() {
        this.userAvatar = BLANK_PROFILE_IMAGE
    }

    ngOnInit() {
        this.userService.currentUser.pipe(takeUntil(this.ngUnsubscribe)).subscribe((user: User) => {
            this.userAvatar = user.photo
        })
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }
}
